import { render, staticRenderFns } from "./bandaccount.vue?vue&type=template&id=2c5da92e&scoped=true"
import script from "./bandaccount.vue?vue&type=script&lang=js"
export * from "./bandaccount.vue?vue&type=script&lang=js"
import style0 from "./bandaccount.vue?vue&type=style&index=0&id=2c5da92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5da92e",
  null
  
)

export default component.exports